// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateTenancyOrderNoteDTO } from '../models';
import { TenancyOrderNoteDTO } from '../models';
/**
 * TenancyOrderNotesApi - axios parameter creator
 * @export
 */
export const TenancyOrderNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a note to a tenancy order
         * @param {string} tenancyOrderId Tenancy order id
         * @param {CreateTenancyOrderNoteDTO} createTenancyOrderNoteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyOrderNote(tenancyOrderId: string, createTenancyOrderNoteDTO: CreateTenancyOrderNoteDTO, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyOrderId' is not null or undefined
            if (tenancyOrderId === null || tenancyOrderId === undefined) {
                throw new RequiredError('tenancyOrderId','Required parameter tenancyOrderId was null or undefined when calling createTenancyOrderNote.');
            }
            // verify required parameter 'createTenancyOrderNoteDTO' is not null or undefined
            if (createTenancyOrderNoteDTO === null || createTenancyOrderNoteDTO === undefined) {
                throw new RequiredError('createTenancyOrderNoteDTO','Required parameter createTenancyOrderNoteDTO was null or undefined when calling createTenancyOrderNote.');
            }
            const localVarPath = `/v2/tenancy-orders/{tenancyOrderId}/notes`
                .replace(`{${"tenancyOrderId"}}`, encodeURIComponent(String(tenancyOrderId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateTenancyOrderNoteDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createTenancyOrderNoteDTO !== undefined ? createTenancyOrderNoteDTO : {}) : (createTenancyOrderNoteDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a Tenancy Order Note from a Tenancy Order
         * @param {string} tenancyOrderNoteId Tenancy order note id
         * @param {string} tenancyOrderId Tenancy order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote(tenancyOrderNoteId: string, tenancyOrderId: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyOrderNoteId' is not null or undefined
            if (tenancyOrderNoteId === null || tenancyOrderNoteId === undefined) {
                throw new RequiredError('tenancyOrderNoteId','Required parameter tenancyOrderNoteId was null or undefined when calling deleteNote.');
            }
            // verify required parameter 'tenancyOrderId' is not null or undefined
            if (tenancyOrderId === null || tenancyOrderId === undefined) {
                throw new RequiredError('tenancyOrderId','Required parameter tenancyOrderId was null or undefined when calling deleteNote.');
            }
            const localVarPath = `/v2/tenancy-orders/{tenancyOrderId}/notes/{tenancyOrderNoteId}`
                .replace(`{${"tenancyOrderNoteId"}}`, encodeURIComponent(String(tenancyOrderNoteId)))
                .replace(`{${"tenancyOrderId"}}`, encodeURIComponent(String(tenancyOrderId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get notes for a tenancy order
         * @param {string} tenancyOrderId Tenancy order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyOrderNotes(tenancyOrderId: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyOrderId' is not null or undefined
            if (tenancyOrderId === null || tenancyOrderId === undefined) {
                throw new RequiredError('tenancyOrderId','Required parameter tenancyOrderId was null or undefined when calling getTenancyOrderNotes.');
            }
            const localVarPath = `/v2/tenancy-orders/{tenancyOrderId}/notes`
                .replace(`{${"tenancyOrderId"}}`, encodeURIComponent(String(tenancyOrderId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenancyOrderNotesApi - functional programming interface
 * @export
 */
export const TenancyOrderNotesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add a note to a tenancy order
         * @param {string} tenancyOrderId Tenancy order id
         * @param {CreateTenancyOrderNoteDTO} createTenancyOrderNoteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyOrderNote(tenancyOrderId: string, createTenancyOrderNoteDTO: CreateTenancyOrderNoteDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyOrderNoteDTO> {
            const localVarAxiosArgs = TenancyOrderNotesApiAxiosParamCreator(configuration).createTenancyOrderNote(tenancyOrderId, createTenancyOrderNoteDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a Tenancy Order Note from a Tenancy Order
         * @param {string} tenancyOrderNoteId Tenancy order note id
         * @param {string} tenancyOrderId Tenancy order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote(tenancyOrderNoteId: string, tenancyOrderId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = TenancyOrderNotesApiAxiosParamCreator(configuration).deleteNote(tenancyOrderNoteId, tenancyOrderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get notes for a tenancy order
         * @param {string} tenancyOrderId Tenancy order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyOrderNotes(tenancyOrderId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenancyOrderNoteDTO>> {
            const localVarAxiosArgs = TenancyOrderNotesApiAxiosParamCreator(configuration).getTenancyOrderNotes(tenancyOrderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TenancyOrderNotesApi - factory interface
 * @export
 */
export const TenancyOrderNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Add a note to a tenancy order
         * @param {string} tenancyOrderId Tenancy order id
         * @param {CreateTenancyOrderNoteDTO} createTenancyOrderNoteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyOrderNote(tenancyOrderId: string, createTenancyOrderNoteDTO: CreateTenancyOrderNoteDTO, options?: any) {
            return TenancyOrderNotesApiFp(configuration).createTenancyOrderNote(tenancyOrderId, createTenancyOrderNoteDTO, options)(axios, basePath);
        },
        /**
         * Delete a Tenancy Order Note from a Tenancy Order
         * @param {string} tenancyOrderNoteId Tenancy order note id
         * @param {string} tenancyOrderId Tenancy order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote(tenancyOrderNoteId: string, tenancyOrderId: string, options?: any) {
            return TenancyOrderNotesApiFp(configuration).deleteNote(tenancyOrderNoteId, tenancyOrderId, options)(axios, basePath);
        },
        /**
         * Get notes for a tenancy order
         * @param {string} tenancyOrderId Tenancy order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyOrderNotes(tenancyOrderId: string, options?: any) {
            return TenancyOrderNotesApiFp(configuration).getTenancyOrderNotes(tenancyOrderId, options)(axios, basePath);
        },
    };
};

/**
 * TenancyOrderNotesApi - interface
 * @export
 * @interface TenancyOrderNotesApi
 */
export interface TenancyOrderNotesApiInterface {
    /**
     * Add a note to a tenancy order
     * @param {string} tenancyOrderId Tenancy order id
     * @param {CreateTenancyOrderNoteDTO} createTenancyOrderNoteDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrderNotesApiInterface
     */
    createTenancyOrderNote(tenancyOrderId: string, createTenancyOrderNoteDTO: CreateTenancyOrderNoteDTO, options?: any): AxiosPromise<TenancyOrderNoteDTO>;

    /**
     * Delete a Tenancy Order Note from a Tenancy Order
     * @param {string} tenancyOrderNoteId Tenancy order note id
     * @param {string} tenancyOrderId Tenancy order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrderNotesApiInterface
     */
    deleteNote(tenancyOrderNoteId: string, tenancyOrderId: string, options?: any): AxiosPromise<object>;

    /**
     * Get notes for a tenancy order
     * @param {string} tenancyOrderId Tenancy order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrderNotesApiInterface
     */
    getTenancyOrderNotes(tenancyOrderId: string, options?: any): AxiosPromise<Array<TenancyOrderNoteDTO>>;

}

/**
 * TenancyOrderNotesApi - object-oriented interface
 * @export
 * @class TenancyOrderNotesApi
 * @extends {BaseAPI}
 */
export class TenancyOrderNotesApi extends BaseAPI implements TenancyOrderNotesApiInterface {
    /**
     * Add a note to a tenancy order
     * @param {string} tenancyOrderId Tenancy order id
     * @param {CreateTenancyOrderNoteDTO} createTenancyOrderNoteDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrderNotesApi
     */
    public createTenancyOrderNote(tenancyOrderId: string, createTenancyOrderNoteDTO: CreateTenancyOrderNoteDTO, options?: any) {
        return TenancyOrderNotesApiFp(this.configuration).createTenancyOrderNote(tenancyOrderId, createTenancyOrderNoteDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete a Tenancy Order Note from a Tenancy Order
     * @param {string} tenancyOrderNoteId Tenancy order note id
     * @param {string} tenancyOrderId Tenancy order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrderNotesApi
     */
    public deleteNote(tenancyOrderNoteId: string, tenancyOrderId: string, options?: any) {
        return TenancyOrderNotesApiFp(this.configuration).deleteNote(tenancyOrderNoteId, tenancyOrderId, options)(this.axios, this.basePath);
    }

    /**
     * Get notes for a tenancy order
     * @param {string} tenancyOrderId Tenancy order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrderNotesApi
     */
    public getTenancyOrderNotes(tenancyOrderId: string, options?: any) {
        return TenancyOrderNotesApiFp(this.configuration).getTenancyOrderNotes(tenancyOrderId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for TenancyOrderNotesApi
 * Import individual functions for optimal bundle size
 */
/**
 * Add a note to a tenancy order
 * @param {string} tenancyOrderId Tenancy order id
 * @param {CreateTenancyOrderNoteDTO} createTenancyOrderNoteDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createTenancyOrderNote(
    tenancyOrderId: string,
    createTenancyOrderNoteDTO: CreateTenancyOrderNoteDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyOrderNoteDTO> {
    const localVarAxiosArgs = TenancyOrderNotesApiAxiosParamCreator(configuration).createTenancyOrderNote(tenancyOrderId, createTenancyOrderNoteDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a Tenancy Order Note from a Tenancy Order
 * @param {string} tenancyOrderNoteId Tenancy order note id
 * @param {string} tenancyOrderId Tenancy order id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteNote(
    tenancyOrderNoteId: string,
    tenancyOrderId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = TenancyOrderNotesApiAxiosParamCreator(configuration).deleteNote(tenancyOrderNoteId, tenancyOrderId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get notes for a tenancy order
 * @param {string} tenancyOrderId Tenancy order id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getTenancyOrderNotes(
    tenancyOrderId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<TenancyOrderNoteDTO>> {
    const localVarAxiosArgs = TenancyOrderNotesApiAxiosParamCreator(configuration).getTenancyOrderNotes(tenancyOrderId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

